'use client';

// Versao decorativa (estatica) da notificacao de venda da Trakd (mesma cara do
// PurchaseNotificationListener), flutuando suave em loop. Usada na hero, nos cantos
// do dashboard. pointer-events-none (so enfeite).

import { motion } from 'motion/react';

import { BrandIcon } from '@/components/brand-icon';
import { formatBRL } from '@/lib/format/brl';

interface NotifCardProps {
  value: number;
  className: string;
  origin: string;
  delay: number;
}

function NotifCard({ value, className, origin, delay }: NotifCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: [0, -9, 0] }}
      transition={{
        opacity: { duration: 0.7, delay, ease: 'easeOut' },
        y: { duration: 4.6, repeat: Infinity, ease: 'easeInOut', delay },
      }}
      className={`bg-surface/95 ring-border-subtle/60 pointer-events-none absolute z-10 flex w-[240px] items-center gap-3 rounded-2xl p-3 shadow-[0_18px_40px_-12px_rgba(0,0,0,0.6)] ring-1 backdrop-blur-xl md:w-[330px] md:gap-3.5 md:rounded-[20px] md:p-3.5 ${origin} scale-[0.7] sm:scale-[0.82] md:scale-100 ${className}`}
    >
      <BrandIcon
        size={46}
        className="h-[42px] w-[42px] shrink-0 rounded-[12px] md:h-[46px] md:w-[46px] md:rounded-[13px]"
        alt="Trakd"
      />
      <div className="min-w-0">
        <p className="text-ink text-[13px] leading-tight font-bold tracking-tight whitespace-nowrap md:text-sm">
          Venda realizada com Pix
        </p>
        <p className="text-ink-muted mt-0.5 text-[12px] whitespace-nowrap md:text-[13px]">
          Você recebeu: <b className="text-ink font-semibold">{formatBRL(value, 'BRL')}</b>
        </p>
      </div>
      {/* timestamp fixo no canto sup-direito (só desktop) · ml-auto evita encavalar no título */}
      <span className="text-ink-subtle ml-auto hidden self-start pl-2 text-[11px] md:inline">
        agora
      </span>
    </motion.div>
  );
}

/** Dois cards de venda flutuando nos cantos do dashboard (sup-dir e inf-esq). */
export function SaleNotifications() {
  return (
    <>
      <NotifCard
        value={97}
        delay={0}
        origin="origin-top-right"
        className="top-10 right-0 sm:-right-2 md:-right-12"
      />
      <NotifCard
        value={297}
        delay={0.9}
        origin="origin-bottom-left"
        className="bottom-[15%] left-0 sm:-left-2 md:-left-12"
      />
    </>
  );
}

export default SaleNotifications;
